import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getItems } from '../../../api/items';

import { mergeItemsListWithUserData } from '../../../utils/items';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoading,
  handleRequestRejection,
  matchRequest,
  resetLoading,
} from '../../../utils/asyncThunkRequest';

import { NEXT_LINK } from '../constants/itemsHeaders';

export const fetchPinnedItems = createAsyncThunk(
  'items/fetchPinnedItems',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItems(path, {
        cancelToken: source.token,
        params: {
          ...params,
          pinned: true,
        },
      });
      const [itemsResponse, userDataMapResponse] = response;

      return {
        data: mergeItemsListWithUserData(itemsResponse, userDataMapResponse),
        nextLink: itemsResponse.headers[NEXT_LINK] || null,
      };
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchPinnedItemsExtraReducers = builder => {
  builder
    .addCase(fetchPinnedItems.pending, (state, action) => {
      checkAndSetLoading(state.items.pinnedDisplay.pagination, action);
    })
    .addCase(fetchPinnedItems.fulfilled, (state, action) => {
      const { payload } = action;
      if (matchRequest(state.items.pinnedDisplay.pagination, action)) {
        payload.data.items.forEach(item => {
          const itemCIDKey = generateItemCIDKey(item);
          state.items.item.byId[itemCIDKey] = item;
          if (!state.items.item.allIds.includes(itemCIDKey))
            state.items.item.allIds.push(itemCIDKey);
        });
        state.items.pinnedDisplay.layout.push(...payload.data.layout);
        state.items.pinnedDisplay.pagination.next = payload.nextLink;
        resetLoading(state.items.pinnedDisplay.pagination);
      }
    })
    .addCase(fetchPinnedItems.rejected, (state, action) => {
      handleRequestRejection(state.items.pinnedDisplay.pagination, action);
    });
};
